import React, {useState} from "react";
import {Row,Col, Card, Table,Image} from "react-bootstrap";
import './../../../Styles/Admin.css';
import { WadiStyles } from '../../../Styles/WadiStyles';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import moveIcon from './../../../Styles/Icons/move.png';


import {DndContext,closestCenter, KeyboardSensor,PointerSensor,useSensors,useSensor,TouchSensor, DragOverlay} from '@dnd-kit/core';

import { AdminDashboardDraggableItem } from './AdminDashboardDraggableItem';
import { AdminDashboardDroppableItem } from './AdminDashboardDroppableItem';

const AdminDashboardEditComponent = props => {
    const [activeId, setActiveId] = useState(null);

    function handleDragEnd(){
        setActiveId(null);
    }
    function handleDragStart(event){
        setActiveId(event.active.id);
    }
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(TouchSensor),
        useSensor(KeyboardSensor)
    );

    return(
    <>
    {/** NOTE -- TO HIDE SCROLL BAR WE NEED TO DIFFERENTIATE BETWEEN BROWSER TYPE */}
    <Row>  
     <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd} sensors={sensors} autoScroll={false} onDragStart={handleDragStart}>
            {props.locations.map(function (location){
                let index=0;
                return(
                    <>
                    <Col>
                        <Card style={{backgroundColor:'#d1d1ca',height:'75vh', backgroundColor:'#d1d1ca', overflowY:'auto', scrollbarWidth:'none'}}>
                            <Card.Header style={{color:'#4e6437', fontWeight:'bolder'}} >
                            {location.name}
                            </Card.Header>
                            <Card.Body>
                                <Table  responsive>
                                    <tbody>
                                        {props.hours.map(function (hour){
                                            let currentIndex=index;
                                            let lenght = location.bookedHours.length;
                                            if(hour === location.bookedHours[currentIndex]){
                                                if(index<lenght-1){
                                                    index=index+1;
                                                }
                                                if(hour===props.editing.time && location.name===props.editing.location){
                                                    return( 
                                                        <tr style={{color:'#4b1c38', fontWeight:'bold'}}>
                                                            <td>{hour}</td>
                                                          
                                                                <Card style={WadiStyles.dashboard.cardForm}>  
                                                                    <Form> 
                                                                        <Row>
                                                                        <AdminDashboardDraggableItem key={hour+location.name} id={hour+location.name} editing={props.editing}>
                                                                            <Image src={moveIcon} style={{width:'2vw'}}></Image>
                                                                        </AdminDashboardDraggableItem>
                                                                        </Row>
                                                                        <Row className='m-1'  style={{textAlign:'center'}}>
                                                                            <Col>
                                                                                <Form.Group className="mb-3" controlId="party.name">
                                                                                    <Form.Label>Name</Form.Label>
                                                                                    <Form.Control type="name" placeholder={props.editing.party} />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col>
                                                                                <Form.Group className="mb-3" controlId="party.size">
                                                                                <Form.Label>Size</Form.Label>
                                                                                    <Form.Control type="name" placeholder={props.editing.size}/>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row> 
                                                                        <Row className='m-1'  style={{textAlign:'center'}}>
                                                                            <Form.Group className="mb-3" controlId="party.notes">
                                                                                <Form.Label>Notes</Form.Label>
                                                                                <Form.Control type="name" />
                                                                            </Form.Group>
                                                                        </Row>
                                                                    </Form>
                                                                </Card>
                                                            
                                                        </tr>
                                                        )
                                                } else{
                                                    return( 
                                                        <tr style={{color:'#4b1c38', fontWeight:'bold'}}>
                                                            <td>{hour}</td>
                                                        </tr>
                                                    )
                                                }
                                            } else {
                                                return(
                                                <tr style={{color:'#4e6437', fontWeight:'bold'}}>
                                                    <td>{hour}</td> 
                                                    <AdminDashboardDroppableItem key={hour+location.name} id={hour+location.name}>
                                                    </AdminDashboardDroppableItem>
                                                </tr>
                                                )
                                            }
                                            
                                        })}
                                    
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                    </>
                )
            })} 

            <DragOverlay>
                {activeId ? (
                    <Card style={WadiStyles.dashboard.cardOnClick}>
                       <Row className='m-1'  style={{textAlign:'center'}}>
                            <Col>{props.editing.party}</Col>
                            <Col sm='1' style={{paddingRight:'2vw'}}>{props.editing.size}</Col>
                        </Row>
                    </Card>
                ):null
                }
            </DragOverlay>
         
        </DndContext>  
    </Row>
    </>
    );

}

AdminDashboardEditComponent.defaultProps ={

}
AdminDashboardEditComponent.propTypes ={
    hours: PropTypes.arrayOf(String),
    locations: PropTypes.arrayOf(Map),
}

export default (AdminDashboardEditComponent);